<template>
  <div id="forgetpass">
    <div class="login_box">
      <div class="login_cont">
        <div class="login_contRight right">
          <!--<div class="login_header">
            <p id="findPass">找回密码</p>
          </div>
          <div class="login_footer register">
            <p style="margin-top: 30px;">
              <span>手机号</span>
              <input
                type="tel"
                maxlength="11"
                style="width: 285px;padding-left: 10px;"
                placeholder="请输入手机号"
                v-model="phone"
              >
            </p>
            <p>
              <span>图形验证码</span>
              <input
                v-model="picCode"
                type="text"
                style="width: 194px;padding-left: 10px;"
                placeholder="请输入图形验证码"
              >
              <s-identify
                class="picCode"
                :identifyCode="identifyCode"
                :contentWidth="92"
                :contentHeight="42"
                @refreshcode="getRePicCode"
              ></s-identify>
            </p>
            <p>
              <span>短信验证码</span>
              <input
                v-model="phoneCode"
                type="text"
                placeholder="请输入短信验证码"
                style="width: 194px; padding-left: 10px;"
              >
              <button
                class="login_code"
                style="width: 87px;"
                v-bind:disabled="disabled"
                @click="getPhoneCode"
              >{{phoneCodeText}}</button>
            </p>
            <p>
              <span>输入新密码</span>
              <input
                type="password"
                placeholder="请输入新密码"
                style="width: 285px;padding-left: 10px;"
                v-model="pass"
              >
            </p>
            <p>
              <span style="width: 130px;">再次输入新密码</span>
              <input
                type="password"
                placeholder="再次输入新密码"
                style="width: 285px;padding-left: 10px;"
                v-model="confirm"
              >
            </p>
            <button class="register_btn" @click="forgetBtn">确定</button>
          </div>-->
          <el-card class="box-card" style="height: 100%">
            <div slot="header" class="clearfix">
              <span style="color: var(--baseColor)">{{$t('forgotLoginName.title')}}</span>
            </div>
            <div class="content">
              <el-form ref="form">
                <el-form-item>
                  <el-input maxlength="11" v-model="phone" :placeholder="$t('forgotLoginName.phonePlaceholder')"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="rePicCode" :placeholder="$t('registerPc.pleaseEnterGraphicCode')"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <img :src="captcha" class="login_img" height="150" width="40" @click="this.getCaptcha">
                      <!-- <s-identify :identifyCode="identifyCode" class="login_img"
                                  :contentWidth="150"
                                  :contentHeight="40"
                                  @refreshcode="getRePicCode"></s-identify> -->
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item>
                  <el-row>
                    <el-col :span="14">
                      <el-input v-model="phoneCode" :placeholder="$t('registerPc.pleaseEnterSmsVerificationCode')">
                      </el-input>
                    </el-col>
                    <el-col :span="10">
                      <el-button type="primary" @click="getPhoneCode" :disabled="disabled" style="width: 100%; background-color: var(--baseColor);">{{phoneCodeText}}</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
                <!-- <el-form-item>
                  <el-input maxlength="11" v-model="newLoginName" :placeholder="$t('forgotPassword.newUsernamePlaceholder')"></el-input>
                </el-form-item> -->
                <el-form-item>
                  <el-button type="primary" style="width: 100%;background-color: var(--baseColor);border-color:var(--baseColor)" @click="forgetBtn">{{$t('stock.sure')}}</el-button>
                </el-form-item>
              </el-form>
            </div>

          </el-card>
        </div>
      </div>
    </div>
    <el-dialog :title="$t('forgotLogin.usernames')" :visible.sync="isforgetLoginShow" width="25%"
      :close-on-click-modal="false">
        <div style="padding: 5px;">
          <el-row v-for="(item,index) in usernames" :key="index" style="padding: 5px;">
            <el-col :span="12">
              {{ `${$t('forgotLogin.loginName')}:${item['system.LoginUsername']}` }}
            </el-col>
            <el-col :span="10">
                {{ `${$t('forgotLogin.loginNumber')}:${item['system.LoginUserNumber']}` }}
            </el-col>
          </el-row>
        </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="isforgetLoginShow = false">{{ $t('forgotLogin.sure') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SIdentify from "../components/icode";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import $ from "jquery";
export default {
  name: "ForgetLoginName",
  components: {
    SIdentify
  },
  data() {
    return {
      phone: "", //手机号
      picCode: "", //图形验证码
      phoneCode: "", //短信验证码
      identifyCode: "", //注册_图形验证码图片
      identifyCodes: "123456789",
      pass: "", //新密码
      confirm: "", //确认新密码
      phoneCodeText: this.$t('registerPc.getVerificationCode'),
      disabled: false,
      captcha: "",
      verify_token: "",
      realName: "",
      card: "",
      getRealName: false,
      rePicCode: "",
      newLoginName: "",
      isforgetLoginShow: false,
      usernames : [],
      timer1: {},
    };
  },
  mounted: function () {
    //获取图片验证码
    // this.getRePicCode();
    // $("#wrapper").css("background", "#737373");
    this.getCaptcha();
  },
  methods: {
    //获取注册 图片验证码

    getCaptcha() {
      let that = this;
      that.$http({
        url: "/app/SendSms/getSmsPic",
        method: "post",
        data: {

        },
      })
        .then(function (res) {
          let resData = res.data;
          if (resData.status == 200) {
            that.captcha = "data:image/png;base64," + resData.data.data.img;
            that.verify_token = resData.data.data.key;
          } else {
            that.disabled = false;
            that.$message.error(that.$t(res.data.msgId));
          }
        });
      // this.captcha = 'https://server.hk9999z.com/captcha?v='+Math.random();
    },
    // 生成一个随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },

    //获取短信验证码
    getPhoneCode() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$message.error(that.$t('registerPc.phoneFormatIncorrect'));
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let forgetPhone = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/app/SendSms/register_code_e",
            method: "post",
            data: {
              phone: forgetPhone,
              rePicCode: this.rePicCode,
              verifyToken: this.verify_token,
            }
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.getRealName = false;
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success"
              });
              var time = 60;
              that.phoneCodeText = time + "s";
              that.disabled = true;
              that.timer1 = setInterval(function () {
                time--;
                that.phoneCodeText = time + "s";
                if (time <= 0) {
                  that.rePicCode= "";
                  that.getCaptcha();
                  that.phoneCodeText = that.$t('registerPc.getVerificationCode');
                  that.disabled = false;
                  clearInterval(that.timer1);
                }
              }, 1000);
            } else  {
              that.getRealName = false;
              that.realName = '';
              that.card = '';
              that.getCaptcha();
              that.rePicCode = ''
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      }
    },
    forgetBtn() {
      let that = this;
      
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone)) {
        that.$message.error(that.$t('registerPc.phoneFormatIncorrect'));
      }
      // else if (that.picCode != this.captcha) {
      //   that.getCaptcha();
      //   that.$message.error("图片验证码不正确");
      // } 
      else if (that.phoneCode == "") {
        that.$message.error(that.$t('registerPc.pleaseEnterSmsVerificationCode'));
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.phone.toString();
        let forgetPhone = that.encryptMessage(userPhone, publicKey);
        let forgetPassword = that.encryptMessage(that.pass, publicKey);
        let forgetPwConfirm = that.encryptMessage(that.confirm, publicKey);
        let encryptedCode = that.encryptMessage(that.phoneCode, publicKey);
        that
          .$http({
            url: "/app/User/forgotUsername_e",
            method: "post",
            data: {
              phone: forgetPhone,
						  user_name: that.newLoginName,
              code: encryptedCode
            }
          })
          .then(function (res) {
            if (res.data.status == 200) {
              that.usernames = res.data.data;
              that.isforgetLoginShow = true;
              that.rePicCode= "";
              that.getCaptcha();
              that.$message({
                message: that.$t(res.data.msgId),
                type: "success"
              });
            } else {
              that.$message.error(that.$t(res.data.msgId));
              that.rePicCode= "";
              that.getCaptcha();
              that.phoneCodeText = that.$t('registerPc.getVerificationCode');
              that.disabled = false;
              clearInterval(that.timer1);
              
            }
          });
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    }
  }
};
</script>
<style scoped>
@import url("./../assets/css/login.css");

.register > p {
  width: 437px;
  margin-left: 26px;
  height: 40px;
  font-size: 15px;
  line-height: 40px;
  margin-top: 25px;
  box-sizing: border-box;
}
.register > p > span {
  display: inline-block;
  box-sizing: border-box;
  padding-right: 10px;
  text-align: right;
  width: 130px;
  height: 40px;
}
input::-webkit-input-placeholder {
  color: white;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: white;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: white;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: white;
}
.register_btn {
  background: #d11028;
  font-size: 16px;
  line-height: 40px;
  height: 40px;
  margin-left: 165px;
  margin-top: 43px;
  text-align: center;
  width: 287px;
  color: #fff;
  border-radius: 3px;
}
.login_agree {
  margin-left: 163px;
}
#findPass {
  text-align: left;
  background-color: #d9d9d9;
  font-size: 25px;
  padding-left: 45px;
}
.picCode {
  display: inline-block;
  width: 92px;
  height: 42px;
  position: absolute;
  right: 45px;
  top: 156px;
}
.content{
  width: 80%;
  margin: 0 auto;
  /*text-align: center;*/
}
</style>




	


// WEBPACK FOOTER //
// src/components/forgetLoginName.vue